import { render, staticRenderFns } from "./ProgramsSingleNavCoordinator.vue?vue&type=template&id=3c130bc4&"
import script from "./ProgramsSingleNavCoordinator.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleNavCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports